import React, { Suspense } from "react";
import Layout from "./layout";
import View from "views";
import { useSelector } from "react-redux";
import { LAYOUT_TYPE_BLANK } from "constants/theme.constant";
import { Loading } from "components/shared";

const AuthLayout = (props) => {
  const layoutType = useSelector((state) => state?.theme?.layout.type);
  const themeColor = useSelector((state) => state?.theme?.themeColor);
  const primaryColorLevel = useSelector(
    (state) => state?.theme?.primaryColorLevel
  );

  const loadingFallback = (
    <div
      className={`flex min-h-screen items-center justify-center bg-${themeColor}-${primaryColorLevel}`}
    >
      <Loading loading={true} spinnerClass="text-white" />
    </div>
  );

  return (
    <div className="app-layout-blank flex flex-auto flex-col h-[100vh]">
      <Suspense fallback={loadingFallback}>
        {layoutType === LAYOUT_TYPE_BLANK ? (
          <View {...props} />
        ) : (
          <Layout>
            <View {...props} />
          </Layout>
        )}
      </Suspense>
    </div>
  );
};

export default AuthLayout;
